export enum Experiment {
  UseLocalizationService = 'specs.myAccount.UseLocalizationService',
  EnableGeneralSettings = 'specs.membersArea.generalSettingsViewer',
  EnableCornerRadiusSettings = 'specs.membersArea.CornerRadiusSetting',
}
